// extracted by mini-css-extract-plugin
export default {"selectWrapper":"styles_selectWrapper__aHyHq","loadingIcon":"styles_loadingIcon__mmY9U"};